export default {"src":"/_next/static/media/contractor.b0110c68.svg","height":62,"width":61,"blurWidth":0,"blurHeight":0};